function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M27.5 0C12.308 0 0 12.31 0 27.5S12.31 55 27.5 55C42.692 55 55 42.69 55 27.5S42.69 0 27.5 0zm13.507 18.84l-4.514 21.27c-.333 1.507-1.23 1.873-2.483 1.163l-6.875-5.067-3.317 3.194c-.365.365-.675.675-1.385.675l.488-6.997 12.74-11.51c.556-.489-.122-.766-.855-.278L19.06 31.203l-6.786-2.119c-1.474-.465-1.508-1.474.31-2.184l26.514-10.224c1.231-.444 2.306.3 1.907 2.162l.002.002z"
});
function SvgTelegramFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 55 55",
    fill: "none"
  }, props), _ref);
}
export default SvgTelegramFilled;